import React from "react";

export default function FieldProgress_InlineValueNotEmpty(props:any) {

    const onDeleteClick = () => {
        props.onChange(null);
    }

    const notSet = _.isNil(props.value);
    const excess = props.value > 100;
    const value = excess ? Math.floor(100 * (100 / props.value)) : props.value;

    const progressClasses = Classes("ui5-progress", "in-ui5-field", {
        'excess-v2':    excess,
        'not-set':      notSet
    });

    return (
        <React.Fragment>
            <div className="ui5-field-with-delete-on-hover">
                <div className="ui5-field-dropdown-inline-editable w-200" onClick={props.onClick}>
                    <div className={progressClasses} onClick={props.onClick}>
                        <div className="progress-bg">
                            {!!value && <div className="progress-line" style={{width:'{0}%'.f(value)}}/>}
                        </div>

                        {!_.isNil(value) && <div className="progress-label ui5-txt-less-important-small percentage">{"{0}%".f(props.value)}</div>}
                    </div>
                </div>

                <div className="ui5-ico-trash red s-14" onClick={onDeleteClick}/>
            </div>
            {props.children}
        </React.Fragment>
    )
}
